import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <h3>Idle Robotics</h3>
              <p>Industrial Automation Solutions</p>
            </div>
            <p className="footer-description">
              Transforming industries through advanced robotics and automation technology. 
              Empowering businesses to achieve operational excellence.
            </p>
            <div className="footer-social">
              <a href="#" aria-label="LinkedIn">LinkedIn</a>
              <a href="#" aria-label="Twitter">Twitter</a>
              <a href="#" aria-label="YouTube">YouTube</a>
            </div>
          </div>

          {/* Removed Solutions list from Footer */}

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#careers">Careers</a></li>
              <li><a href="#news">News & Media</a></li>
              <li><a href="#partners">Partners</a></li>
              <li><a href="#investors">Investors</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <div className="contact-info">
              <p>📍 Artpark, IISc Bangalore, India</p>
              <p>📧 <a href="mailto:kumarankit@artpark.in" style={{ color: 'inherit', textDecoration: 'underline' }}>kumarankit@artpark.in</a></p>
              <p>📞 <a href="https://wa.me/917477787888" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>+91-7477787888</a></p>
            </div>
            <a href="#contact" className="btn btn-primary">
              Get in Touch
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 idle robotics. All rights reserved.</p>
            <div className="footer-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#cookies">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;